<div class="breadcrumb-container">
  <nav class="breadcrumb" [attr.aria-label]="'FEATURES.BREADCRUMB.ARIA_LABEL' | transloco">
    <ng-container *ngFor="let item of items$ | async; let first = first; let last = last">
      <svg *ngIf="!first" class="separator" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
      </svg>

      <span class="crumb" [class.current]="last" [class.clickable]="!!item.navigate"
            (click)="item.navigate?.()" [attr.aria-current]="last ? 'page' : null">
        <svg *ngIf="first" class="home-icon" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
        </svg>
        {{ item.labelKey ? (item.labelKey | transloco) : item.label }}
      </span>
    </ng-container>
  </nav>
</div>
